import * as React from 'react';
import { RouteComponentProps, Redirect } from "react-router-dom";
import { Fragment } from 'react';
import { Header } from '../components/header';
import { reportRequest, ReportHistory, DATA_REFRESH_TIME } from '../api/dataTypes';
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import { CutRecordsTable } from '../components/table-cutRecords';
import { exportCSV, getRecordsApi } from '../api/api-cutRecords';
import { PromiseHelper } from '../classes/promiseHelper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { DataSelectionHeader } from '../components/dataSelectionHeader';
import { isDistributorRole } from '../api/api-account';

interface State {
    cutRecordsData: ReportHistory[] | null;
    message: string;
    reportRequest: reportRequest;
}

export interface Props { }

export class CutRecordsPage extends React.Component<RouteComponentProps, State> {
    recordsPromise: PromiseHelper<ReportHistory[]> = new PromiseHelper();
    dataTimerId: number | null = null;

    constructor(props: RouteComponentProps) {
        super(props);

        this.state = {
            reportRequest: {
                startDate: moment(new Date(Date.now()))
                    .subtract(7, "days")
                    .toDate(),
                endDate: new Date(Date.now()),
                systemId: 0,
                org: 0,
            },
            cutRecordsData: null,
            message: 'loading...'
        }
    }
    
    componentWillUnmount() {
        this.recordsPromise.clearPromise();
        if (this.dataTimerId !== null) {
            clearInterval(this.dataTimerId);
            this.dataTimerId = null;
        }
    }

    componentDidMount = () => {
        this.getRecords(this.state.reportRequest); 
        this.dataTimerId = window.setInterval(this.getRecords, DATA_REFRESH_TIME);

    };

    render() {
        // This component is called from /, /index.html, and /reports. TODO: Is this the landing page or spool winders?
        // To get the 'tab' on the UI highlight properly redirect the other routes to /reports
        if (this.props.location.pathname !== "/cutRecords") {
            return <Redirect to={{ pathname: "/cutRecords" }} />;
        } else {
            return (
                <Fragment>
                    <Header/>
                    <div className="d-flex header-page-title">
                        <div className="m-2 ml-3 mr-auto">
                            Cut Records
                        </div>

                        <div className="col-2 d-flex justify-content-end align-items-center">
                            <button
                                className="btn btn-outline-secondary m-2 ml-auto button-standard"
                                onClick={() => exportCSV(this.state.reportRequest)}
                            >
                                <FontAwesomeIcon className="mr-4" icon={faDownload} />
                                Export to CSV
                            </button>
                        </div>
                    </div>

                    <DataSelectionHeader
                        getRecords = {this.getRecords}
                        enableOwnerSelection = {isDistributorRole()}
                    />
                    <div className="">
                        <CutRecordsTable
                            cuts={this.state.cutRecordsData}
                            loading={this.state.cutRecordsData === null}
                            showWinderColumn={this.state.reportRequest.systemId === 0}
                        />
                    </div>

                </Fragment>
            )
        }
    }

    

    private getRecords = (request: reportRequest | null) => {
        this.recordsPromise!.newPromise(
            getRecordsApi(request || this.state.reportRequest),
            result => {
                this.setState({
                    reportRequest: request || this.state.reportRequest,
                    cutRecordsData: result,
                    message: ''
                });
            },
            e => {
                console.log(`Error caught in page-cutRecords.getRecords(). ${e!.message}`);
                alert('Error getting cut records');
            }
        );
    }
}